import React, { useState } from "react"
import { Link } from "react-router-dom"
import { Collapse } from "reactstrap"
import ProtectedMenuItem from "components/Common/ProtectedMenuItem"
import { PERMISSIONS } from "utils/permissionConfig"

const AdminNav = props => {
  const [items, setItems] = useState(false)
  const [userManagement, setUserManagement] = useState(false)
  const [systemSetup, setSystemSetup] = useState(false)

  return (
    <Collapse
      isOpen={props.leftMenu}
      className="navbar-collapse"
      id="topnav-menu-content"
    >
      <ul className="navbar-nav">
        <ProtectedMenuItem
          permission={[
            PERMISSIONS.SHOW_WAREHOUSE,
            PERMISSIONS.SHOW_PROJECT,
            PERMISSIONS.SHOW_PROVIDER,
            PERMISSIONS.SHOW_PROVINCE,
            PERMISSIONS.SHOW_CURRENCY,
            PERMISSIONS.SHOW_FUND_CODE,
            PERMISSIONS.SHOW_SHIPMENT,
            PERMISSIONS.SHOW_FACILITY,
            PERMISSIONS.SHOW_IP,
          ]}
          permissionLogic="any"
        >
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle arrow-none"
              onClick={e => {
                e.preventDefault()
                setSystemSetup(!systemSetup)
              }}
              to="#"
            >
              <i className="mdi mdi-cog me-2"></i>
              System Setup {props.menuOpen}
              <div className="arrow-down"></div>
            </Link>
            <div className={"dropdown-menu"}>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_WAREHOUSE}>
                <Link to="/warehouse" className="dropdown-item">
                  <i className="mdi mdi-warehouse me-2"></i>
                  Warehouse
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROJECT}>
                <Link to="/projects" className="dropdown-item">
                  <i className="mdi mdi-order-bool-descending me-2"></i>
                  Project
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVIDER}>
                <Link to="/providers" className="dropdown-item">
                  <i className="mdi mdi-order-bool-descending me-2"></i>
                  Providers
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVINCE}>
                <Link to="/provinces" className="dropdown-item">
                  <i className="mdi mdi-google-maps me-2"></i>
                  Province
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_CURRENCY}>
                <Link to="/currencies" className="dropdown-item">
                  <i className="mdi mdi-currency-usd me-2"></i>
                  Currency
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_FUND_CODE}>
                <Link to="/fund-codes" className="dropdown-item">
                  <i className="mdi mdi-cash-multiple me-2"></i>
                  Fund Code
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_SHIPMENT}>
                <Link to="/shipments" className="dropdown-item">
                  <i className="mdi mdi-truck-delivery me-2"></i>
                  Shipment
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_FACILITY}>
                <Link to="/facilities" className="dropdown-item">
                  <i className="mdi mdi-home me-2"></i>
                  Facilities
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_IP}>
                <Link to="/ips" className="dropdown-item">
                  <i className="mdi mdi-account-group me-2"></i>
                  IPs
                </Link>
              </ProtectedMenuItem>
            </div>
          </li>
        </ProtectedMenuItem>
        <ProtectedMenuItem
          permission={[
            PERMISSIONS.SHOW_COMMODITY_CLASSIFICATION,
            PERMISSIONS.SHOW_ITEM_CATEGORY,
            PERMISSIONS.SHOW_ITEM,
          ]}
          permissionLogic="any"
        >
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle arrow-none"
              onClick={e => {
                e.preventDefault()
                setItems(!items)
              }}
              to="#"
            >
              <i className="mdi mdi-order-bool-descending me-2"></i>
              Items {props.menuOpen}
              <div className="arrow-down"></div>
            </Link>
            <div className={"dropdown-menu"}>
              <ProtectedMenuItem
                permission={PERMISSIONS.SHOW_COMMODITY_CLASSIFICATION}
              >
                <Link to="/commodity-classifications" className="dropdown-item">
                  Unit Classification
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_ITEM_CATEGORY}>
                <Link to="/item-categories" className="dropdown-item">
                  Item Category
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_ITEM}>
                <Link to="/items" className="dropdown-item">
                  Item
                </Link>
              </ProtectedMenuItem>
            </div>
          </li>
        </ProtectedMenuItem>

        <ProtectedMenuItem
          permission={[PERMISSIONS.SHOW_USER, PERMISSIONS.SHOW_ROLE]}
          permissionLogic="any"
        >
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle arrow-none"
              onClick={e => {
                e.preventDefault()
                setUserManagement(!userManagement)
              }}
              to="/users"
            >
              <i className="bx bx-user me-2"></i>
              User Management {props.menuOpen}
              <div className="arrow-down"></div>
            </Link>
            <div className={"dropdown-menu"}>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_USER}>
                <Link to="/users" className="dropdown-item">
                  Users
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_ROLE}>
                <Link to="/roles" className="dropdown-item">
                  Roles
                </Link>
              </ProtectedMenuItem>
            </div>
          </li>
        </ProtectedMenuItem>
        <ProtectedMenuItem permission={PERMISSIONS.SHOW_ACTIVITY_LOG}>
          <li className="nav-item ">
            <Link className="nav-link " to="/activity-logs">
              <i className="bx bx-history me-2"></i>
              Activity Logs
            </Link>
          </li>
        </ProtectedMenuItem>
        <ProtectedMenuItem permission={PERMISSIONS.MANAGE_ACTION_REQUEST}>
          <li className="nav-item ">
            <Link className="nav-link " to="/provider-receipt-action-requests">
              <i className="bx bx-task me-2"></i>
              Action Requests
            </Link>
          </li>
        </ProtectedMenuItem>
        <ProtectedMenuItem permission={PERMISSIONS.MANAGE_RETURN_REQUEST}>
          <li className="nav-item ">
            <Link className="nav-link " to="/return-requests">
              <i className="bx bx-undo me-2"></i>
              Re-allocation Management
            </Link>
          </li>
        </ProtectedMenuItem>
        <ProtectedMenuItem permission={PERMISSIONS.MANAGE_PROVIDER_TRANSFER}>
          <li className="nav-item ">
            <Link className="nav-link " to="/admin/provider-transfers">
              <i className="bx bx-transfer me-2"></i>
              Provider Transfers
            </Link>
          </li>
        </ProtectedMenuItem>
        <li className="nav-item ">
          <Link className="nav-link " to="/dashboard">
            <i className="bx bx-home-circle me-2"></i>
            Dashboard
          </Link>
        </li>
      </ul>
    </Collapse>
  )
}

export default AdminNav
